import { Crown, Gift } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { imgUrl } from "@/lib/api";

const BRAND_CLS = {
  Grammer: "bg-sky-500/10 text-sky-400 border-sky-500/30",
  Proboss: "bg-orange-500/10 text-orange-400 border-orange-500/30",
  "Total Source": "bg-amber-500/10 text-amber-400 border-amber-500/30",
};

export const BrandBadge = ({ brand }) => (
  <span className={`inline-block border px-2 py-0.5 text-[10px] font-mono-x font-bold uppercase tracking-wider ${BRAND_CLS[brand] || "border-slate-600 text-slate-300"}`}>
    {brand}
  </span>
);

export const PremiumBadge = () => (
  <span data-testid="premium-badge" className="inline-flex items-center gap-1 px-2 py-0.5 bg-[#1F2230]/80 backdrop-blur border border-orange-500/40 text-orange-400 text-[10px] font-mono-x font-bold uppercase tracking-wider">
    <Crown className="w-3 h-3" />Premium
  </span>
);

export const StockBadge = ({ stock, testid }) => {
  const { t } = useLang();
  const [cls, label] = stock <= 0 ? ["text-amber-400", t("out_stock")] : ["text-emerald-400", t("in_stock")];
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 text-xs font-mono-x ${cls}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {label}
    </span>
  );
};

export const SaleBadge = ({ pct, testid }) => (
  <span data-testid={testid} className="inline-flex items-center px-2 py-0.5 bg-red-500 text-white text-xs font-mono-x font-bold tracking-wider">
    −{Math.round(pct)}%
  </span>
);

export const GiftBadge = ({ testid }) => {
  const { t } = useLang();
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1 px-2 py-0.5 bg-emerald-500 text-[#1F2230] text-[10px] font-mono-x font-bold uppercase tracking-wider">
      <Gift className="w-3 h-3" />{t("gift")}
    </span>
  );
};

export const GiftBox = ({ p }) => {
  const { t, lang } = useLang();
  const text = (lang === "lt" ? p.gift_lt : p.gift_en) || p.gift_lt;
  if (!text) return null;
  return (
    <div data-testid="product-gift" className="mt-6 flex items-center gap-4 border border-emerald-500/40 bg-emerald-500/10 p-3">
      {p.gift_image && <img src={imgUrl(p.gift_image)} alt={text} className="w-16 h-16 object-contain bg-white shrink-0" />}
      <div>
        <div className="flex items-center gap-1.5 text-xs font-mono-x font-bold uppercase tracking-wider text-emerald-400"><Gift className="w-3.5 h-3.5" />{t("gift_with")}</div>
        <div className="text-sm text-slate-200 mt-1">{text}</div>
      </div>
    </div>
  );
};
